import React from "react";
import {Tooltip, withStyles} from "@material-ui/core";
import H1Title from "../components/H1Title";
import {centerVertically} from "./util";

function LeftBarTitle({theme, title, onClick, style, startButton}) {
    return <div style={ style ? style : {padding: '24px 0px 16px 0px'}}>

            <H1Title noWrap={true} style={{
                maxWidth: 'calc(100% - 8px)',
                color: theme.palette.primary.main,
            }}>

                <div style={{display: 'inline', cursor : 'pointer'}} onClick={() => {
                    onClick && onClick();
                    return false;
                }}>
                    <div style={{display: "flex"}}>
                    { startButton &&
                        centerVertically(startButton)
                    }
                        {title && <Tooltip placement={'bottom-start'} title={title}><span>{title}</span></Tooltip>}
                    </div>
                </div></H1Title>

    </div>;
}

export default withStyles({}, {withTheme: true})(LeftBarTitle);
